var map = {
	"./Authority.vue": "2081",
	"./Demo.vue": "c38c",
	"./Error.vue": "5c91",
	"./Register.vue": "0f9e",
	"./ibtVerification/BankWireTransfer.vue": "4363",
	"./ibtVerification/IbtVerification.vue": "b9b6",
	"./ibtVerification/confirmId/Default.vue": "f513",
	"./ibtVerification/confirmPoa/Default.vue": "b443",
	"./ibtVerification/financialInformation/Default.vue": "1d69",
	"./ibtVerification/ibtSuccess/Default.vue": "294e",
	"./openAccount/OpenAccount.vue": "6d16",
	"./openAccount/accountConfiguration/Default.vue": "350f",
	"./openAccount/openAccountSuccess/Default.vue": "e00f",
	"./openAccount/personalInformation/Default.vue": "efa3",
	"./poaVerification/PoaVerification.vue": "9572",
	"./poaVerification/poaInformation/Default.vue": "5a26",
	"./poaVerification/poaUpload/Default.vue": "9ee1",
	"./poaVerification/poaVerificationSuccess/Default.vue": "8f81",
	"./poiVerification/PoiVerification.vue": "e699",
	"./poiVerification/idInformation/Default.vue": "c653",
	"./poiVerification/idUpload/Default.vue": "b2fd",
	"./poiVerification/idVerificationSuccess/Default.vue": "a6d2",
	"./verificationStatus/Default.vue": "e9f7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0cc0";